import { Fragment } from 'react';
import GlobalStyle from './theme/globalStyle';
import FontIconsStyle from './theme/fonts';

function Layout({ children }) {
    return (
        <Fragment>
            <GlobalStyle />
            <FontIconsStyle />
            {children}
        </Fragment>
    );
}
export default Layout;
